import { RESTUtils } from '@galigeo-store/ui-lib';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { PortalAppContext } from '../../../state/portal-appcontext.js';
import { RightPanel } from '../../right-panel/right-panel.component.js';
import '../general/general.component.js';
import '../header/admin-header.component.js';

@customElement('admin-right-panel')
export class AdminRightPanel extends RightPanel {
  static get styles() {
    return [...super.styles];
  }

  constructor() {
    super();
  }

  render() {
    if (this.route === 'admin/general') {
      document.title = 'General Settings';
      return html`<general-admin-page></general-admin-page>`;
    }
    const url = new URL(this.getIframeUrl());

    document.title = this.selectedItem.label;

    url.searchParams.set('ggo_token', RESTUtils.getToken());
    url.searchParams.set('crossDomain', 'true');
    url.searchParams.set('lang', PortalAppContext.getCurrentUser().lang);

    return html`
    <div class="slds-grid slds-grid_vertical" style="height:100%">
      <admin-header title="${this.selectedItem.label}"></admin-header>
      <iframe
        src="${url.href}"
        style="border: none"
        @load="${this.handleIframeLoad}"
        width="100%"
        height="100%"
      ></iframe>
    </div>
    `;
  }
}
